import { gql } from '@apollo/client/core'

export default gql`
    mutation LinkGuaranteeTargetToGuarantees($guaranteeTarget: GuaranteeTargetInput!, $guaranteeIds: [ID!]!) {
        linkGuaranteeTargetToGuarantees(input: { guaranteeTarget: $guaranteeTarget, guaranteeIds: $guaranteeIds }) {
            errors
            status
            statusCode
        }
    }
`
